<script setup>
import {defineProps} from 'vue'

defineProps({
  withoutIcon: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div class="alert-message-danger">
    <div class="pe-2 icon" v-if="!withoutIcon">
      <img src="~@shared-images/icons/danger-icon.svg" alt="danger" />
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>
